import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';
import { AxiosServiceError } from 'interfaces/general';
import { FileUploaduserRequest } from 'api/fileStorage';

/**
 * Hook para cambiar el avatar de usuario.
 *
 * Realiza una mutación a la API para actualizar el avatar del usuario.
 * Maneja el éxito y los errores mostrando mensajes al usuario.
 *
 * @returns {object} Objeto con la función para cambiar el avatar y el estado de carga.
 * @example
 * const { mutate, isLoading } = EditUserAvatar();
 */
function EditUserAvatar() {
  const { showApiError, showSuccess } = useGlobalContext();
  const { fileStorage: fileStorageApi } = useApiContext();
  const { t } = useTranslation('global');

  const edituserImage = useMutation(
    (data: FileUploaduserRequest) =>
      fileStorageApi.files.uploadUserFile({ file: data }),
    {
      onSuccess: () => {
        showSuccess(t('success.updateImage'));
      },
      onError: (error: AxiosServiceError) => {
        showApiError(error, t('errorMessages.errorUpdatingImage'));
      }
    }
  );

  return edituserImage;
}

export default EditUserAvatar;
